import { render } from "./UnitElectionReport.vue?vue&type=template&id=0edec778&scoped=true"
import script from "./UnitElectionReport.vue?vue&type=script&lang=js"
export * from "./UnitElectionReport.vue?vue&type=script&lang=js"

import "./UnitElectionReport.vue?vue&type=style&index=0&id=0edec778&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edec778"]])

export default __exports__